import { io } from "socket.io-client";

export const socket = io("https://tulip-back-end-socketio.onrender.com");
